import { API_JWT_BASE_URL } from '../http'

export const SEARCH_FIRMWARES_API = `${API_JWT_BASE_URL}/Firmware/search`
export const IMPORT_FIRMWARE_API = `${API_JWT_BASE_URL}/Firmware/import`
export const DELETE_FIRMWARE_API = `${API_JWT_BASE_URL}/Firmware`
export const UPDATE_FIRMWARE_API = `${API_JWT_BASE_URL}/Firmware/`
export const GET_FIRMWARE_API = `${API_JWT_BASE_URL}/Firmware/details/`
export const UNOBSOLETE_FIRMWARES_API = `${API_JWT_BASE_URL}/Firmware/reactivate`

export const FIRMWARES_QUERY_KEYS = {
  SEARCH_FIRMWARES: 'SEARCH_FIRMWARES',
  GET_FIRMWARE: 'GET_FIRMWARE',
  IMPORT_FIRMWARE: 'IMPORT_FIRMWARE',
  DELETE_FIRMWARE: 'DELETE_FIRMWARE',
  UPDATE_FIRMWARE: 'UPDATE_FIRMWARE',
  UNOBSOLETE_FIRMWARES: 'UNOBSOLETE_FIRMWARES'
}
